const calculateAge = (birthYear) => new Date().getFullYear() - birthYear;

const Staff = () => {
  const employees = [
    {
      name: 'Данил Данильченко',
      photo: '/Данил Данильченко.jpg',
      birthYear: 2006,
      position: 'Основатель'
    },
    {
      name: 'Виталий Коваль',
      photo: '/Виталий Коваль.jpg',
      birthYear: 2006,
      position: 'Главный разработчик'
    },
    {
      name: 'Богдан Евдусев',
      photo: '/Богдан Евдусев.jpg',
      birthYear: 2005,
      position: 'Менеджер'
    }
  ];

  return (
    <section id='staff' className='py-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-top-80 before:-right-80 before:w-[800px] before:h-[800px] before:bg-gradient-radial before:from-cyan-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='text-center mb-20 animate'>
          <h2 className='section-title'>
            Наша команда
          </h2>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto'>
            Небольшая команда, которая сама пишет код, отвечает на письма и отвечает за результат — без прослоек и отделов.
          </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8'>
          {employees.map((employee, index) => (
            <div
              key={index}
              className='employee-card glass-card rounded-2xl p-6 relative overflow-hidden animate'
            >
              <div className='w-24 h-24 bg-gradient-to-br from-cyan-400 to-sky-500 rounded-full flex items-center justify-center text-[#0b1e3d] text-2xl mb-4 transition-all duration-300 hover:rotate-12 hover:scale-110 hover:shadow-lg overflow-hidden'>
                <img src={employee.photo} alt={employee.name} className='w-full h-full object-cover' />
              </div>
              <h3 className='text-xl font-montserrat font-bold mb-2 text-gray-900 dark:text-white relative
                after:content-[""] after:absolute after:bottom-[-5px] after:left-0 after:w-0 after:h-0.5 after:bg-cyan-400 after:transition-all after:duration-300 group-hover:after:w-full'>
                {employee.name}
              </h3>
              <p className='text-gray-600 dark:text-gray-400 mb-1'>Возраст: {calculateAge(employee.birthYear)}</p>
              <p className='text-gray-600 dark:text-gray-400 mb-4'>Должность: {employee.position}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Staff;
